/** @enum {string} */
export const ProductTypes = {
    /** Use for package item */
    Service: 'service',
    /** Use for any other item */
    Product: 'product'
};


// WEBPACK FOOTER //
// ./src/app/shared/ecommerce/enums/productTypes.ts